<template>
  <div class="media-gallery-x-of-y">
    <span class="media-gallery-x-of-y__x">{{ activeItem?.index }}</span>
    <slot name="divider">
      /
    </slot>
    <span class="media-gallery-x-of-y__y">{{ galleryItems.length }}</span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  name: string
}>()

const { galleryItems, activeItem } = useUiMediaGallery(props.name)
</script>

<style>
@import url("~layers/app/components/Ui/MediaGallery/XofY.css");
</style>
